<template>
    <div class="container full-width">
        <template v-if="shippingType == ShippingType.DELIVERY">
            <div class="text-subtitle1">Delivery type</div>
            <q-list class="bg-white">
                <q-item dense :disable="!canRegular" tag="label" v-ripple>
                    <q-item-section avatar>
                        <q-radio
                            :disable="!canRegular"
                            :value="shippingMode"
                            @input="onChoose"
                            val="REGULAR"
                            color="primary"
                        />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>Regular</q-item-label>
                    </q-item-section>
                </q-item>

                <q-item
                    dense
                    :disable="!canExpress || totalItem > 15"
                    tag="label"
                    v-ripple
                >
                    <q-item-section avatar>
                        <q-radio
                            :disable="!canExpress || totalItem > 15"
                            :value="shippingMode"
                            @input="onChoose"
                            val="EXPRESS"
                            color="green"
                        />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>Express</q-item-label>
                        <q-item-label caption
                            >+50 Baht express fee(Max 15 items or 15
                            kg).</q-item-label
                        >
                    </q-item-section>
                </q-item>

                <q-item dense :disable="!canNationwide" tag="label" v-ripple>
                    <q-item-section avatar top>
                        <q-radio
                            :disable="!canNationwide"
                            :value="shippingMode"
                            @input="onChoose"
                            val="NATIONWIDE"
                            color="cyan"
                        />
                    </q-item-section>
                    <q-item-section>
                        <q-item-label>Nationwide</q-item-label>
                        <q-item-label caption
                            >2-5 days delivery depend on distance.
                        </q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </template>
    </div>
</template>

<script>
import { ShippingType } from "@/entities/order/order";
import { mapState, mapGetters } from "vuex";
export default {
    name: "DeliveryType",
    data() {
        return {
            ShippingType: ShippingType,
            // deliveryType: null,
        };
    },
    computed: {
        ...mapState({
            shippingType: (state) => state["checkout"]["shippingType"],
            shippingMode: (state) => state["checkout"]["shippingMode"],
            canRegular: (state) => state["checkout"]["canRegular"],
            canExpress: (state) => state["checkout"]["canExpress"],
            canNationwide: (state) => state["checkout"]["canNationwide"],
            activeCustomer: (state) => state["activeCustomer"]["customer"],
        }),
        ...mapGetters({
            totalItem: "checkout/totalItem",
        }),
    },
    watch: {
        activeCustomer: {
            handler: function (value) {
                console.log("watch activeCustomer", value);
                this.$store.dispatch("checkout/loadPolygon");
            },
        },
        shippingType: {
            handler: function (value) {
                console.log("watch shippingType", value);
                if (value == ShippingType.DELIVERY) {
                    this.$store.dispatch("checkout/loadPolygon");
                }
            },
        },
        shippingMode: {
            handler: function (value) {
                console.log("watch shippingMode", value);
            },
        },
    },
    mounted() {
        // load polygon then recalculate cost again
        this.$store.dispatch("checkout/loadPolygon").then(() => {
            this.$store.dispatch("checkout/getCost");
        });
    },
    methods: {
        onChoose(value) {
            console.log("onChoose", value);
            this.$store.commit("checkout/setShippingMode", value);
            this.$store.dispatch("checkout/getCost");
        },
    },
};
</script>

<style scoped>
.container {
    padding: 0px 8px;
}
</style>
